export const columns = [
  {
    Header: 'Fornecedor',
    id: 'supplier',
    accessor: 'supplier',
    sortable: false,
  },
  {
    Header: 'Fim do Recebimento',
    id: 'finishedAt',
    accessor: 'finishedAt',
    width: 200,
  },
  {
    Header: 'Tempo',
    id: 'time',
    accessor: 'time',
    width: 100,
  },
  {
    Header: 'Ação',
    id: 'action',
    accessor: 'action',
    width: 100,
    sortable: false,
  },
]
